import dayjs from 'dayjs';
import { date, number, object, string } from 'yup';

import { MUST_BE_INTEGER, REQUIRED_FIELD } from '@/config/text.const';
import { EnvUtils } from '@/utils/env.utils';

export const bcValidationSchema = object().shape({
  stockCode: string()
    .max(50)
    .required(REQUIRED_FIELD),

  comments: string()
    .max(200, 'Must be maximum ${max} characters')
    .nullable(),

  salesHandoverNumber: string()
    .max(50, 'Must be maximum ${max} characters')
    .nullable(),
    
  quantity: number()
    .typeError('Must be a number')
    .min(0, 'Must be greater than or equal to ${min}')
    .integer(MUST_BE_INTEGER)
    .required(REQUIRED_FIELD),

  unitPrice: number()
    .typeError('Must be a number')
    .required(REQUIRED_FIELD),

  unitPriceFrequency: string()
    .test((value, { parent, createError }) => {
      if (parent?.billingType != 'Subscription') {
        return true;
      }
    
      if (!value) {
        return createError({
          message: 'Unit Price Frequency is required for Billing Type "Subscription"'
        });
      }
    
      return true;
    })
    .defined()
    .nullable(),

  billingInterval: string()
    .test((value, { parent, createError }) => {
      if (parent?.billingType != 'Subscription') {
        return true;
      }
    
      if (!value) {
        return createError({
          message: 'Billing Interval is required for Billing Type "Subscription"'
        });
      }
    
      return true;
    })
    .defined()
    .nullable(),

  billingType: string()
    .test((value, context) => {
      if (value !== 'Subscription') {
        return true;
      }

      if (context.parent?.unitPriceFrequency) return true;

      return context.createError({
        path: 'unitPriceFrequency',
        message: 'Unit Price Frequency is required for billing type "Subscription"'
      });
    })
    .test((value, context) => {
      if (value !== 'Subscription') {
        return true;
      }

      if (context.parent.billingInterval) return true;

      return context.createError({
        path: 'billingInterval',
        message: 'Billing Interval is required for billing type "Subscription"'
      });
    })
    .required('Billing Type is required field'),

  ...(!EnvUtils.isProRataFirstPeriodEnabled() ? {
    lineStartDate: date().nullable()
      .test((value, context) => {
        const contractStartDate = context.options.context?.contract?.contractStartDate;

        if (value && contractStartDate && !dayjs(value).isSameOrAfter(dayjs(contractStartDate), 'date')) {
          return context.createError({
            path: 'lineStartDate',
            message: 'Line Start Date can\'t be less than Contract Start Date'
          });
        }
        return true;
      }),
  } : {}),

  ...(EnvUtils.isProRataFirstPeriodEnabled() ? {
    proRataEndDate: date().nullable(),
  } : {}),
    
  unitType: string()
    .max(10, 'Must be maximum ${max} characters')
    .nullable(),
});
